// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1374":"b531e788","4929":"7e22e371"}[chunkId] + ".chunk.css";
};